import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

export interface TabItem {
  to: string;
  label: string;
  icon: string;
  /** 「发现」Tab 本期推迟 → hidden = true（路由存在但不渲染入口） */
  hidden?: boolean;
  badge?: number;
}

export const TAB_ITEMS: TabItem[] = [
  { to: '/chat', label: '聊天', icon: '💬' },
  { to: '/feed', label: 'Feed', icon: '🌐' },
  { to: '/trade', label: '交易', icon: '🔄' },
  { to: '/rewards', label: '挖矿', icon: '⛏️' },
  { to: '/me', label: '我的', icon: '👤' },
];

export interface TabBarProps {
  items?: TabItem[];
}

/**
 * 底部 Tab（<768px 单栏形态）。
 * 「发现」Tab 已开放（路由 `/discover` + 入口可见）；如需临时下线，给该项加 `hidden: true`。
 */
export function TabBar({ items = TAB_ITEMS }: TabBarProps): JSX.Element {
  const visible = items.filter((i) => !i.hidden);
  return (
    <nav className="safe-bottom flex h-14 shrink-0 items-stretch border-t border-line bg-panel md:hidden">
      {visible.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            clsx(
              'relative flex flex-1 flex-col items-center justify-center gap-0.5 text-xs',
              isActive ? 'text-accent' : 'text-dim',
            )
          }
        >
          <span aria-hidden className="text-base leading-none">
            {item.icon}
          </span>
          <span>{item.label}</span>
          {item.badge && item.badge > 0 ? (
            <span className="absolute right-1/2 top-1 translate-x-4 rounded-full bg-err px-1.5 text-[10px] text-white">
              {item.badge > 99 ? '99+' : item.badge}
            </span>
          ) : null}
        </NavLink>
      ))}
    </nav>
  );
}

export default TabBar;
